// import Modal from "@mui/material/Modal";
// import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import dayjs from "dayjs";
import { useEffect, useState } from "react";

import commoncss from "../../../myfin_v2/css/common.module.css";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import bookclosurecss from "../../../myfin_v2/css/bookclosure.module.css";
import Modal from "../../../myfin_v2/elements/Modal";
import InputGroup from "../../../myfin_v2/elements/InputGroup";
import Dropdown from "../../../myfin_v2/elements/Dropdown";
import { Button } from "../../../myfin_v2/elements/Button";
import { ReactComponent as CloseIcon } from "../../../myfin_v2/assets/icons/close.svg";
import { ReactComponent as CalenderIcon } from "../../../myfin_v2/assets/icons/calender.svg";


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  height: 650,
  bgcolor: "background.paper",
  outline: "none",
  p: 4,
};
const CreateFsModal = (props) => {
  const {
    open,
    handleClose,
    handleChangeValue,
    allCompany,
    selectedIr,
    uploadPreset,
    uploadPresetID,
    handleSubmitFs,
    workspaceData,
    ProjectName,
  } = props;

  const hash = selectedIr?.reduce((p, c) => (p[c.ir_id] ? p[c.ir_id].push(c) : p[c.ir_id] = [c], p), {});
  const newData = Object.keys(hash).map(k => ({ ir_id: k, car: hash[k] }));
  if (newData.length > 0) {
    const opt2 = newData.map((det) => ({
      label: det.ir_id,
      value: det.ir_id,
    }));
    setIROpt(opt2);
  }
  const IRName = (ir_id) => {
    const nameOfType = selectedIr.filter((adj) => adj.ir_id === ir_id);
    const result = nameOfType[0]?.ir_name
      ? nameOfType[0]?.ir_name
      : "NA";
    return result;
  }


  const [parentOpt, setParentOpt] = useState([]);
  const [irOpt, setIROpt] = useState([]);


  useEffect(() => {
    if (allCompany.length > 0) {
      const opt1 = allCompany.map((det) => ({
        label: det.company_name,
        value: det._id,
      }));
      setParentOpt(opt1);
    }


  }, []);

  return (
    <>
      {open && (
        <Modal
          title="Create Consol FS"
          bodycss={commoncss.unsetPadding}
          width="40%"
          headerActions={
            <CloseIcon
              onClick={handleClose}
              className="clickable"
            />
          }
          onClose={() => console.log("Modal Closed")}
          footerActions={
            <>
              <Button
                btnColor={buttoncss.secondary}
                onClick={handleClose}
                label="Close"
              />
              <Button
                btnColor={buttoncss.primary}
                label="Create Consol FS"
                onClick={handleSubmitFs}

              />
            </>
          }
        >
          <div className={commoncss.pd1530}>
            <InputGroup
              class_="mb-2"
              label="Consol Name"
              inputs={[
                <>
                  <input
                    name="tag"
                    placeholder="Consol Name"
                    onChange={(e) => handleChangeValue(e.target.value, "consol_name")}

                  />
                </>,
              ]}
            />

            <Dropdown
              label="Parent Company"
              options={parentOpt}
              onSelect={(opt) => handleChangeValue(opt.value, "parent_company")}

              placeHolder={"Select Parent Company"}
            />
            <Dropdown
              label="Investment Register"
              options={irOpt}
              onSelect={(opt) => handleChangeValue(opt.value, "link_ir")}

              placeHolder={"Select Investment Register"}
            />

            <div className="my-2">
              <Button
                btnColor={buttoncss.primary}
                label="Upload Preset"
                onClick={uploadPreset}
              />
              &nbsp;&nbsp;&nbsp;<small>{ProjectName(uploadPresetID)}</small>
            </div>
            <InputGroup
              inputs={[
                <>
                  <InputGroup
                    label="Current financial year"
                    inputs={[
                      <>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer components={["DatePicker", "MobileDatePicker"]}>
                            <MobileDatePicker
                              className={`${commoncss.datePickerContainer} ${commoncss.clickable}`}
                              // value={dayjs()}
                              onChange={(value) => {
                              }}
                              format="DD-MMM-YYYY"
                              slotProps={{
                                textField: {
                                  InputProps: {
                                    disableUnderline: true,
                                  },
                                  sx: {
                                    "& fieldset": {
                                      border: "none",
                                    },
                                  },
                                },
                              }}
                            />
                          </DemoContainer>
                        </LocalizationProvider>
                        <span className="icon">
                          <CalenderIcon className="vaMiddle" width={20} height={20} />
                        </span>
                      </>
                    ]}
                  />

                </>,
                <>
                  <InputGroup
                    label="Previous financial year"
                    inputs={[
                      <>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer components={["DatePicker", "MobileDatePicker"]}>
                            <MobileDatePicker
                              className={`${commoncss.datePickerContainer} ${commoncss.clickable}`}
                              // value={dayjs()}
                              onChange={(value) => {
                              }}
                              format="DD-MMM-YYYY"
                              slotProps={{
                                textField: {
                                  InputProps: {
                                    disableUnderline: true,
                                  },
                                  sx: {
                                    "& fieldset": {
                                      border: "none",
                                    },
                                  },
                                },
                              }}
                            />
                          </DemoContainer>
                        </LocalizationProvider>
                        <span className="icon">
                          <CalenderIcon className="vaMiddle" width={20} height={20} />
                        </span>
                      </>
                    ]}
                  />
                </>,
              ]}
            />

          </div>
        </Modal>
      )}
    </>
  );
};

export default CreateFsModal;
